function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'arancia-atlas-orange': 'rgb(252, 147, 3)','arancio-argos-red': 'rgb(251, 100, 69)','arancio-borealis-orange': 'rgb(251, 164, 0)','arancio-bruciato-orange': 'rgb(215, 76, 16)','arancio-xanto-orange': 'rgb(230, 74, 55)','azzurro-thetys-blue': 'rgb(140, 160, 184)','balloon-white-white': 'rgb(232, 232, 232)','bianco-asopo-white': 'rgb(243, 250, 253)','bianco-comes-white': 'rgb(251, 251, 251)','bianco-isi-white': 'rgb(192, 203, 205)','bianco-monocerus-white': 'rgb(237, 237, 237)','blu-aegir-blue': 'rgb(44, 174, 254)','blu-astraeus-blue': 'rgb(0, 2, 76)','blu-caelum-blue': 'rgb(5, 74, 227)','blu-cepheus-blue': 'rgb(57, 191, 254)','blu-eleos-blue': 'rgb(65, 141, 216)','blu-fontus-blue': 'rgb(49, 50, 71)','blu-glauco-blue': 'rgb(8, 199, 227)','blu-le-mans-blue': 'rgb(6, 144, 255)','blu-nereid-blue': 'rgb(37, 57, 188)','blu-nethuns-blue': 'rgb(19, 54, 234)','blu-nila-blue': 'rgb(1, 126, 244)','blu-notte-blue': 'rgb(33, 46, 88)','blu-uranus-blue': 'rgb(1, 119, 164)','bronzo-zante-bronze': 'rgb(176, 141, 87)','giallo-auge-yellow': 'rgb(254, 190, 5)','giallo-evros-yellow': 'rgb(226, 143, 1)','giallo-inti-yellow': 'rgb(254, 209, 54)','giallo-orion-yellow': 'rgb(254, 167, 0)','giallo-spica-yellow': 'rgb(242, 195, 47)','giallo-tenerife-yellow': 'rgb(242, 244, 39)','grigio-antares-grey': 'rgb(166, 173, 183)','grigio-ater-grey': 'rgb(114, 114, 116)','grigio-estoque-grey': 'rgb(172, 172, 174)','grigio-hati-grey': 'rgb(199, 215, 231)','grigio-keres-grey': 'rgb(111, 111, 111)','grigio-liqueo-grey': 'rgb(133, 137, 141)','grigio-lynx-grey': 'rgb(112, 113, 118)','grigio-nimbus-grey': 'rgb(107, 114, 120)','grigio-telesto-grey': 'rgb(118, 146, 165)','grigio-titans-grey': 'rgb(94, 98, 100)','nero-aldebaran-black': 'rgb(13, 16, 21)','nero-granatus-black': 'rgb(146, 85, 93)','nero-helene-black': 'rgb(21, 22, 24)','nero-nemesis-black': 'rgb(49, 47, 48)','nero-noctis-black': 'rgb(41, 41, 39)','nero-pegaso-black': 'rgb(8, 13, 16)','oros-elios-bronze': 'rgb(184, 139, 96)','rosso-arancio-red': 'rgb(221, 61, 13)','rosso-bia-red': 'rgb(193, 0, 1)','rosso-efesto-red': 'rgb(244, 34, 31)','rosso-leto-red': 'rgb(182, 0, 53)','rosso-mars-red': 'rgb(212, 0, 0)','verde-citrea-green': 'rgb(154, 249, 93)','verde-ermes-green': 'rgb(84, 110, 81)','verde-gea-lucido-green': 'rgb(139, 137, 112)','verde-ithaca-green': 'rgb(174, 255, 126)','verde-mantis-green': 'rgb(125, 194, 59)','verde-metallic-green': 'rgb(143, 192, 40)','verde-scandal-green': 'rgb(132, 225, 46)','verde-selvans-green': 'rgb(103, 197, 47)','viola-30-purple': 'rgb(178, 124, 182)','viola-aletheia-purple': 'rgb(73, 42, 197)','viola-pasifae-purple': 'rgb(107, 6, 134)','ibis-white': 'rgb(255, 255, 255)','brilliant-black': 'rgb(0, 0, 0)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor','plaque letter color','plaque letter color - sv','plaque letter color - j','r block color','badge letter color','badge letter color - sv','badge letter color - j',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
